"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const errors_1 = require("./errors");
class ParsedCmd {
    constructor(parts, errors) {
        this.parts = parts;
        this.errors = errors;
    }
    get prefixValue() {
        const firstPart = this.parts[0];
        return firstPart && firstPart.kind === "Value"
            ? firstPart.value
            : undefined;
    }
    findNamedPart(options) {
        return this.parts.find((p) => p.kind === "NamedValue" &&
            p.name === (p.isShort ? options.short : options.name));
    }
}
exports.ParsedCmd = ParsedCmd;
class CmdParser {
    parseArgs(args) {
        const errors = new errors_1.ErrorsImpl();
        const state = { onlyPositional: false, errors };
        return new ParsedCmd(new Array().concat(...args.map(arg => this.parseArg(arg, state))), errors);
    }
    parseArg(arg, context) {
        if (context.onlyPositional) {
            return [{ kind: "Value", value: arg }];
        }
        if (arg == "--") {
            context.onlyPositional = true;
            return [];
        }
        const isNamed = /^(--|-|\/)(.*)$/;
        const isNamedMatch = isNamed.exec(arg);
        if (!isNamedMatch) {
            return [{ kind: "Value", value: arg }];
        }
        const prefix = isNamedMatch[1];
        const rest = isNamedMatch[2];
        const namedArg = /^([a-zA-Z0-9:_\-]+)(=(.*))?$/;
        const namedArgMatch = namedArg.exec(rest);
        if (namedArgMatch) {
            const varName = namedArgMatch[1];
            const value = namedArgMatch[3];
            let isShort = prefix === "-";
            if (isShort && varName.length > 1) {
                return [...varName].map((char, idx) => ({
                    kind: "NamedValue",
                    name: char,
                    // "-abc=test" will be treated as "-a -b -c=test"
                    // The assembler will report an error for this case.
                    value: idx !== varName.length - 1 ? undefined : value,
                    isShort,
                    isGroup: true,
                }));
            }
            return [
                {
                    kind: "NamedValue",
                    name: varName,
                    value,
                    isShort,
                    isGroup: false,
                },
            ];
        }
        else {
            context.errors.addError({
                kind: "MalformedArgumentError",
                argument: arg,
                message: `Argument "${arg}" is malformed. Use "--IDENTIFIER" to specify a named argument.`,
            });
            return [];
        }
    }
}
exports.CmdParser = CmdParser;
//# sourceMappingURL=parser.js.map